export default {"src":"/_next/static/media/payment-ideal.2cea4bda.svg","height":30,"width":45,"blurWidth":0,"blurHeight":0};